
import { mapActions } from 'vuex'
import { required, email, minLength } from 'vuelidate/lib/validators'
import LoleH1 from '~/components/text/lole-h1'
import LoleP from '~/components/text/lole-p'
import LoleBtn from '~/components/buttons/lole-btn'
import LoleInput from '~/components/form/input/lole-input'
import LoleCheckbox from '~/components/form/checkbox/lole-checkbox'
import LoleFormError from '~/components/form/error/lole-error-form'
export default {
  name: 'LoleSignup',
  components: {
    LoleH1,
    LoleInput,
    LoleP,
    LoleBtn,
    LoleCheckbox,
    LoleFormError,
  },
  props: {
    wording: {
      type: Object,
      required: true,
    },
    wordingErrors: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    formSignup: {
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      acceptsMarketing: false,
    },
    acceptTerms: false,
    submitted: false,
    errors: [],
    loading: false,
  }),
  validations: {
    formSignup: {
      firstName: { required },
      lastName: { required },
      email: { required, email },
      password: { required, minLength: minLength(6) },
    },
  },
  methods: {
    ...mapActions({
      vxSubscribe: 'klaviyo/subscribe',
    }),
    async signup() {
      this.$v.$touch()
      this.submitted = true
      this.errors = []
      if (!this.$v.$invalid && this.acceptTerms) {
        this.loading = true
        try {
          const qs = this.$route.query
          const routeToWishlist = 'wishlist' in qs
          const routeTo = routeToWishlist
            ? 'wishlist'
            : this.localePath('/account')
          await this.$store.dispatch('customer/createCustomer', this.formSignup)
          if (this.formSignup.acceptsMarketing)
            this.subscribeKlaviyo(this.formSignup.email)
          this.$router.push(this.localePath(routeTo))
        } catch (e) {
          if (
            e.message.includes('Email has already been taken') ||
            e.message.includes('E-mail est déjà pris')
          ) {
            this.errors.push({ code: 'TAKEN-MAIL' })
          } else if (
            e.message.includes(
              'Creating Customer Limit exceeded. Please try again later.'
            ) ||
            e.message.includes('Trop de tentatives de création client')
          ) {
            this.errors.push({ code: 'LIMIT-EXCEEDED-SIGNUP' })
          } else if (
            e.message.includes(
              'please click the link included to verify your email address.'
            ) ||
            e.message.includes('verifier votre')
          ) {
            this.errors.push({ code: 'CUSTOMER_DISABLED' })
          } else {
            this.$sentryException(e, {
              source: 'component',
              component: 'signup',
              level: 'fatal',
              extra: 'Customer signup failed - customer/customerCreate',
            })
            this.errors.push({ code: 'ERROR-NOT-LISTED', message: e.message })
          }
        }
        this.loading = false
      }
    },
    async subscribeKlaviyo(email) {
      try {
        await this.vxSubscribe({
          email,
          source: 'Creation account signup form',
        })
      } catch (e) {
        this.$sentryException(e, {
          source: 'components/lole-signup-newsletter',
          level: 'fatal',
          extra: 'Newsletter Subscribe component failed',
        })
      }
    },
  },
}
